<div class="Init">
  <header class="sticky-top">
    <div class="header_title text-center py-2">おしゃべりリマインダー</div>
  </header>

  <!-- ローディング -->
  <loading v-model:active="loader.is_loading" :is-full-page="loader.is_full_page"></loading>
  <!-- メッセージ -->
  <b-alert v-model="message.is_alert" dismissible :variant="message.variant">{{ message.message }}</b-alert>

  <b-container class="px-4">
    <div class="text-center mt-4">
      <img alt="おしゃべりリマインダー" src="../../assets/chatty-reminders-image-1000x545.png" class="img-fluid" />
    </div>
    <div class="text-center mt-4 mx-4">プライバシーポリシーは<a href="/PrivacyPolicy">こちら</a></div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="home()">「おしゃべりリマインダー」とは</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="qa()">よくあるご質問</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="privacy_policy()">プライバシーポリシー</b-button>
    </div>
    <div class="mt-3 d-grid gap-2">
      <b-button variant="outline-primary" class="btn" @click="terms_of_service()">利用規約</b-button>
    </div>
  </b-container>
  
</div>